// Libraries
import React, { useState } from 'react'

// Components
import LeadershipModal from '../../page/resources/company/leadershipModal'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

// helpers
import ImgUtil from '../../../utils/img.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'

const SpeakerTile = (props: any) => {
  const {
    headshot,
    company,
    miniBio,
    firstName,
    lastName,
    role,
    twitterProfile,
    linkedInProfile,
    seeBioText,
    microcopy,
  } = props

  const [modalOpen, setModalOpen] = useState(false)
  const [modalData, setModalData] = useState({})

  let fullName = `${firstName} ${lastName}`
  let image = headshot?.image?.file?.url
  let imageAlt = headshot?.altText

  const openModal = () => {
    setModalData({
      fullName,
      role,
      miniBio,
      twitterProfile,
      linkedInProfile,
      image,
      microcopy,
    })
    setModalOpen(true)
  }

  const closeModal = () => setModalOpen(false)

  return (
    <div className="SpeakerText__Bio">
      <WrapperImage
        className="SpeakerText__Bio-Headshot"
        src={ImgUtil.getResizedImageUrl(image, `width=280`)}
        alt={imageAlt}
        threshold={650}
      />
      <div className="SpeakerText__Bio-Description">
        {fullName && (
          <Typography className="SpeakerText__Bio-Name" type="lead">
            {fullName}
          </Typography>
        )}
        {role && company && (
          <Typography className="SpeakerText__Bio-Role" type="body">
            {role}, {company}
          </Typography>
        )}
        {miniBio && (
          <>
            <Typography className="SpeakerText__Bio-Body" type="body">
              {renderRichText(miniBio)}
            </Typography>
            <a onClick={openModal}>
              <Typography className="SpeakerText__Bio-More" type="body">
                {seeBioText}
              </Typography>
            </a>
          </>
        )}
      </div>

      <LeadershipModal
        onClose={closeModal}
        open={modalOpen}
        data={modalData}
        contentType="speakerText"
      />
    </div>
  )
}

export default SpeakerTile
